
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Actions from '../../../../components/docs/Actions';
export const metadata = {
  toc: true,
  layout: 'guide',
  description: 'Use our sample credentials to test different Auth methods in the Plaid Sandbox environment'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Header title='Testing Auth methods' subtitle='Testing Instant Match, Database Auth, and micro-deposit flows' mdxType="Header" />
    <h4 {...{
      "id": "sandbox-configuration"
    }}>{`Sandbox configuration`}</h4>
    <p>{`To test in the `}<a parentName="p" {...{
        "href": "/docs/sandbox"
      }}>{`Sandbox environment`}</a>{`, point your backend at the Sandbox URL when creating the `}<inlineCode parentName="p">{`link_token`}</inlineCode>{`. The environment is determined by the `}<inlineCode parentName="p">{`link_token`}</inlineCode>{`, so there is no client-side Link configuration to change:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-text",
        "metastring": "switcher=false #API host",
        "switcher": "false",
        "#API": true,
        "host": true
      }}>{`https://sandbox.plaid.com
`}</code></pre>
    <h4 {...{
      "id": "testing-instant-match"
    }}>{`Testing Instant Match`}</h4>
    <h5 {...{
      "id": "test-credentials"
    }}>{`Test credentials`}</h5>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Sandbox input`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Successful credentials`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Erroneous credentials`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Institution Name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Houndstooth Bank (`}<inlineCode parentName="td">{`ins_109512`}</inlineCode>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`––`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Username`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`user_good`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`––`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Password`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`pass_good`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`––`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Account Selection`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Plaid Saving (****1111)`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`––`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Routing number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`021000021`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Any other routing number`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Account number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`1111222233331111`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Any other account number`}</td>
        </tr>
      </tbody>
    </table>
    <h5 {...{
      "id": "entering-the-link-flow"
    }}>{`Entering the Link flow`}</h5>
    <ul>
      <li parentName="ul">{`Search for "Houndstooth Bank" in Link.`}</li>
      <li parentName="ul">{`Use the input data in the table above to simulate the desired outcome.`}</li>
    </ul>
    <h4 {...{
      "id": "testing-instant-micro-deposits"
    }}>{`Testing Instant Micro-deposits`}</h4>
    <p>{`You can also test this flow in Sandbox with no code by using the `}<a parentName="p" {...{
        "href": "https://plaid.com/link-demo"
      }}>{`Link Demo`}</a>{`.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Sandbox input`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Successful credentials`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Erroneous credentials`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Institution name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Windowpane Bank (`}<inlineCode parentName="td">{`ins_135858`}</inlineCode>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`––`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Routing number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`333333334`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Any other value (if testing upgrade path)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Account number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`1111222233330000`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`––`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Deposit code`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`ABC`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Any other value`}</td>
        </tr>
      </tbody>
    </table>
    <h5 {...{
      "id": "entering-the-primary-link-flow"
    }}>{`Entering the primary Link flow`}</h5>
    <ul>
      <li parentName="ul">{`Search for "Windowpane Bank" in Link. `}</li>
      <li parentName="ul">{`When prompted, use the input data in the table above to simulate the desired outcome.`}</li>
      <li parentName="ul">{`For all other fields, you can use any values.`}</li>
    </ul>
    <h5 {...{
      "id": "testing-the-upgrade-path-from-same-day-micro-deposits-to-instant-micro-deposits"
    }}>{`Testing the upgrade path from Same-Day Micro-deposits to Instant Micro-deposits`}</h5>
    <ul>
      <li parentName="ul">{`If you have enabled Same-Day Micro-deposits, enter gibberish into the search bar to ensure no institutions will be found, then click on Link with account numbers.`}</li>
      <li parentName="ul">{`If you have configured Same-Day Micro-deposits with Auth Type Select, choose "Manually" from the menu.`}</li>
      <li parentName="ul">{`When prompted, enter the input data in the table above. For all other fields, you can use any values.`}</li>
      <li parentName="ul">{`Note that, unlike the primary Instant Micro-deposits flow, the routing and account number entries will be on separate panes.`}</li>
    </ul>
    <h4 {...{
      "id": "testing-database-auth-or-database-insights"
    }}>{`Testing Database Auth or Database Insights`}</h4>
    <p>{`You can also test this flow in Sandbox with no code by using the `}<a parentName="p" {...{
        "href": "https://plaid.com/link-demo"
      }}>{`Link Demo`}</a>{`.`}</p>
    <h5 {...{
      "id": "test-credentials-us-based-sessions"
    }}>{`Test credentials (US-based sessions)`}</h5>
    <p>{`To simulate a `}<inlineCode parentName="p">{`database_insights_pass`}</inlineCode>{` result:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Sandbox input`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Credentials`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Routing number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Any routing number (e.g. `}<inlineCode parentName="td">{`110000000`}</inlineCode>{`)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Account number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`1111222233331111`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <p>{`To simulate a `}<inlineCode parentName="p">{`database_insights_pass_with_caution`}</inlineCode>{` result:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Sandbox input`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Credentials`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Routing number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Any routing number (e.g. `}<inlineCode parentName="td">{`110000000`}</inlineCode>{`)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Account number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`1111222233333333`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <p>{`Any other account number will simulate a `}<inlineCode parentName="p">{`database_insights_fail`}</inlineCode>{` result, e.g.:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Sandbox input`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Credentials`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Routing number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Any routing number (e.g. `}<inlineCode parentName="td">{`110000000`}</inlineCode>{`)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Account number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`1111222233332222`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <p>{`To simulate a 100 name match score, use the name "John Smith".`}</p>
    <h5 {...{
      "id": "test-credentials-ca-based-sessions"
    }}>{`Test credentials (CA-based sessions)`}</h5>
    <p>{`To simulate a `}<inlineCode parentName="p">{`database_insights_pass`}</inlineCode>{` result:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Sandbox input`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Credentials`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Institution number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`110`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Branch number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`11111`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Account number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`11223311`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <p>{`To simulate a `}<inlineCode parentName="p">{`database_insights_pass_with_caution`}</inlineCode>{` result:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Sandbox input`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Credentials`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Institution number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`110`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Branch number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`11111`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Account number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`11223333`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <p>{`Any other input will simulate a `}<inlineCode parentName="p">{`database_insights_fail`}</inlineCode>{` result, e.g.:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Sandbox input`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Credentials`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Institution number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`110`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Branch number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`11111`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Account number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`11223322`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <h5 {...{
      "id": "entering-the-link-flow-1"
    }}>{`Entering the Link flow`}</h5>
    <ul>
      <li parentName="ul">{`If you have configured Database Auth or Database Insights with Auth Type Select, choose "Manually" from the menu.`}</li>
      <li parentName="ul">{`If you have configured Database Auth or Database Insights with Embedded Search, choose "Connect Manually".`}</li>
      <li parentName="ul">{`If you have enabled Database Auth or Database Insights without either of the above options, enter gibberish into the search bar to ensure no institutions will be found, then click on "Link with account numbers".`}</li>
      <li parentName="ul">{`Use input data from the table above to simulate various outcomes.`}</li>
    </ul>
    <h4 {...{
      "id": "testing-automated-micro-deposits"
    }}>{`Testing Automated Micro-deposits`}</h4>
    <p>{`You can also test this flow in Sandbox with no code by using the `}<a parentName="p" {...{
        "href": "https://plaid.com/link-demo"
      }}>{`Link Demo`}</a>{`.`}</p>
    <h5 {...{
      "id": "test-credentials-1"
    }}>{`Test credentials`}</h5>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Sandbox input`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Successful credentials`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Erroneous credentials`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Institution Name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Houndstooth Bank (`}<inlineCode parentName="td">{`ins_109512`}</inlineCode>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`––`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Username`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`user_good`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`––`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Password`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`microdeposits_good`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`––`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Account Selection`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Plaid Checking (****0000)`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`––`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Routing number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`021000021`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Any other routing number`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Account number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`1111222233330000`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Any other account number`}</td>
        </tr>
      </tbody>
    </table>
    <h5 {...{
      "id": "entering-the-link-flow-2"
    }}>{`Entering the Link flow`}</h5>
    <ul>
      <li parentName="ul">{`Search for "Houndstooth Bank" in Link.`}</li>
      <li parentName="ul">{`Use the input data in the table above to simulate the desired outcome.`}</li>
    </ul>
    <p>{`The micro-deposit verification will automatically succeed after twenty-four hours. To test a failed micro-deposit, or to skip the twenty-four hour waiting period, use the `}<inlineCode parentName="p">{`/sandbox/item/set_verification_status`}</inlineCode>{` endpoint to manually control the Item's micro-deposit verification status.`}</p>
    <h4 {...{
      "id": "testing-same-day-micro-deposits"
    }}>{`Testing Same-Day Micro-deposits`}</h4>
    <p>{`You can also test this flow with no code by using the `}<a parentName="p" {...{
        "href": "https://plaid.com/link-demo"
      }}>{`Link Demo`}</a>{`.`}</p>
    <h5 {...{
      "id": "test-credentials-2"
    }}>{`Test credentials`}</h5>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Sandbox input`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Successful credentials`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Erroneous credentials`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Routing number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`110000000`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`––`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Account number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`1111222233330000`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`––`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Deposit code`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`ABC`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Any other value`}</td>
        </tr>
      </tbody>
    </table>
    <h5 {...{
      "id": "initiating-micro-deposits-in-link"
    }}>{`Initiating micro-deposits in Link`}</h5>
    <ul>
      <li parentName="ul">{`If you have configured Same-Day Micro-deposits with Auth Type Select, choose "Manually" from the menu`}</li>
      <li parentName="ul">{`If you have enabled Same-Day Micro-deposits without Auth Type Select, enter gibberish into the search bar to ensure no institutions will be found, then click on "Link with account numbers".`}</li>
      <li parentName="ul">{`Use the input data in the table above to simulate the desired outcome.`}</li>
    </ul>
    <h5 {...{
      "id": "verifying-micro-deposits-in-link"
    }}>{`Verifying micro-deposits in Link`}</h5>
    <ul>
      <li parentName="ul">{`Call `}<inlineCode parentName="li">{`/item/public_token/exchange`}</inlineCode>{` with your `}<inlineCode parentName="li">{`public_token`}</inlineCode>{` from the Link session in previous step to receive an `}<inlineCode parentName="li">{`access_token`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Call `}<inlineCode parentName="li">{`/link/token/create`}</inlineCode>{` and provide the `}<inlineCode parentName="li">{`access_token`}</inlineCode>{` from the previous step to receive a `}<inlineCode parentName="li">{`link_token`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Open Link with your `}<inlineCode parentName="li">{`link_token`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`In the deposit code field, enter `}<inlineCode parentName="li">{`ABC`}</inlineCode></li>
    </ul>
    <h5 {...{
      "id": "sms-verification"
    }}>{`SMS verification`}</h5>
    <p>{`Text message verification cannot be tested in the Sandbox environment. Text messages will only be sent in Production, and will only be sent to users who do not click "Continue as guest" on the Link consent pane. To test receipt of the `}<inlineCode parentName="p">{`SMS_MICRODEPOSITS_VERIFICATION`}</inlineCode>{` webhook in Sandbox, you can use `}<inlineCode parentName="p">{`/sandbox/item/fire_webhook`}</inlineCode>{`; in Sandbox, this endpoint will always fire a webhook with the status of `}<inlineCode parentName="p">{`MANUALLY_VERIFIED`}</inlineCode>{` regardless of the actual verification status.`}</p>
    <h4 {...{
      "id": "testing-micro-deposit-events"
    }}>{`Testing micro-deposit events`}</h4>
    <p>{`Micro-deposits that are generated in Sandbox will never be posted by default.
In order to generate a posted event that you can see when you query `}<inlineCode parentName="p">{`/bank_transfer/event/sync`}</inlineCode>{`, you can use the `}<inlineCode parentName="p">{`/sandbox/bank_transfer/simulate`}</inlineCode>{` endpoint.`}</p>
    <p>{`Simulating a posted event in Sandbox does not generate a webhook. You will need to call `}<inlineCode parentName="p">{`/sandbox/bank_transfer/fire_webhook`}</inlineCode>{` each time you want a
webhook to be published for testing.`}</p>
    <h4 {...{
      "id": "testing-identity-match-with-same-day-micro-deposit-items"
    }}>{`Testing Identity Match with Same Day micro-deposit Items`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Sandbox input`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Successful credentials`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Erroneous credentials`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Routing number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`011401533`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`110000000`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Account number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`1111222233330000`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`1111222233330000`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Deposit code`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`ABC`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`ABC`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <ul>
      <li parentName="ul">{`Complete the Same-Day Micro-deposits flow as detailed above`}</li>
      <li parentName="ul">{`Call `}<inlineCode parentName="li">{`/identity/match`}</inlineCode>{` using any variation of data in order to test the matching algorithm `}</li>
      <li parentName="ul">{`The identity data of the test user is as follows:`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Field`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Sandbox identity`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Alberta Bobbeth Charleson`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Email`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "mailto:accountholder0@example.com"
            }}>{`accountholder0@example.com`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Phone`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1112223333`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Street`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`2992 Cameron Road`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`City`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Malakoff`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Region`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`NY`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Country`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`US`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Postal Code`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`14236`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "testing-database-match"
    }}>{`Testing Database Match`}</h4>
    <p>{`You can also test this flow in Sandbox with no code by using the `}<a parentName="p" {...{
        "href": "https://plaid.com/link-demo"
      }}>{`Link Demo`}</a>{`.`}</p>
    <h5 {...{
      "id": "test-credentials-3"
    }}>{`Test credentials`}</h5>
    <p>{`To simulate a `}<inlineCode parentName="p">{`database_matched`}</inlineCode>{` result:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Sandbox input`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Credentials`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Routing number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`110000000`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Account number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`1111222233331111`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`John Smith`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <p>{`Any other input will simulate no match and proceed with Same-Day Micro-deposits, e.g.:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Sandbox input`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Credentials`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Routing number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`110000000`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Account number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`1111222233332222`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`John Smith`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <h5 {...{
      "id": "entering-the-link-flow-3"
    }}>{`Entering the Link flow`}</h5>
    <ul>
      <li parentName="ul">{`If you have enabled Database Match, enter gibberish into the search bar to ensure no institutions will be found, then click on Link with account numbers.`}</li>
      <li parentName="ul">{`If you have configured Database Match with Auth Type Select, choose "Manually" from the menu.`}</li>
      <li parentName="ul">{`Use the input data in the table above to simulate different outcomes.`}</li>
    </ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "sandbox-configuration",
        level: 4,
        title: "Sandbox configuration",
      },
{
        id: "testing-instant-match",
        level: 4,
        title: "Testing Instant Match",
      },
{
        id: "testing-instant-micro-deposits",
        level: 4,
        title: "Testing Instant Micro-deposits",
      },
{
        id: "testing-database-auth-or-database-insights",
        level: 4,
        title: "Testing Database Auth or Database Insights",
      },
{
        id: "testing-automated-micro-deposits",
        level: 4,
        title: "Testing Automated Micro-deposits",
      },
{
        id: "testing-same-day-micro-deposits",
        level: 4,
        title: "Testing Same-Day Micro-deposits",
      },
{
        id: "testing-micro-deposit-events",
        level: 4,
        title: "Testing micro-deposit events",
      },
{
        id: "testing-identity-match-with-same-day-micro-deposit-items",
        level: 4,
        title: "Testing Identity Match with Same Day micro-deposit Items",
      },
{
        id: "testing-database-match",
        level: 4,
        title: "Testing Database Match",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
